__webpack_require__.p = "/akademi-kocu/";